import type { RouteLocationRaw } from 'vue-router';

export interface BreadcrumbItem {
  label: string;
  to?: RouteLocationRaw;
  onClick?: () => void;
}

export const COMPANY_SECTION_LABELS = {
  projects: 'Projects',
  notes: 'Notes',
  checkins: 'Auto check ins',
} as const;
